import { useFragment, graphql } from 'react-relay';
import { useState, useRef, useEffect } from 'react';
import braintreeClient from 'braintree-web/client';
import paypalClient from 'braintree-web/paypal';
import { logCheckoutError } from '../../helpers/logCheckoutError';

export function usePayPalClient({ viewer: viewerRef }) {
    const viewer = useFragment(
        graphql`
            fragment usePayPalClient_viewer on Viewer {
                clientToken {
                    value
                }
            }
        `,
        viewerRef
    );
    const [paypalState, setPaypalState] = useState(null);
    const paypalPromise = useRef(null);

    useEffect(() => {
        paypalPromise.current = new Promise(resolve => {
            const clientToken = viewer?.clientToken?.value;

            braintreeClient.create(
                { authorization: clientToken },
                (clientError, clientInstance) => {
                    if (clientError) {
                        logCheckoutError(clientError, 'paypal');
                        return;
                    }

                    paypalClient.create(
                        {
                            client: clientInstance,
                        },
                        (paypalError, paypal) => {
                            if (paypalError) {
                                logCheckoutError(paypalError, 'paypal');
                                return;
                            }
                            resolve({ paypal, teardown: paypal.teardown });
                            setPaypalState(paypal);
                        }
                    );
                }
            );
        });
        return () => {
            if (paypalPromise.current) {
                paypalPromise.current.then(({ teardown }) => teardown());
            }
        };
    }, [viewer.clientToken.value]);

    return paypalState;
}
